"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.colors = exports.zIndexes = exports.variants = exports.th = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var fontSizes = [12, 14, 16, 18, 20, 24, 32, 38, 40, 48, 56, 62, 70];
var space = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60];
var shadows = {
  small: "0px 3px 6px #00000029"
};

var th = function th(path) {
  return function (props) {
    return (0, _get.default)(props.theme, path);
  };
};

exports.th = th;

var getValue = function getValue(props, variant) {
  return typeof variant === "function" ? variant(props) : variant;
}; // Creates a function that returns a matching prop value when passed a string


var variants = function variants(prop, values) {
  return function (props) {
    var variant = props[prop] && values[props[prop]];
    return variant && getValue(props, variant);
  };
}; // All the code that controls vertical stacking is in one place. The idea being
// that you could slip something in between later if need be, which you couldn't
// if you did 1, 2, 3, etc, because z-index doesn't support decimals.


exports.variants = variants;
var zIndexes = {
  notification: 9000,
  overlay: 8000,
  modal: 7000,
  navigation: 6000,
  dropdown: 5000
};
exports.zIndexes = zIndexes;
var colors = {
  trueBlack: "#000",
  black: "#273C49",
  lightBlack: "#385264",
  fiord: "#3B515F",
  white: "#FFFFFF",
  primaryText: "#FFFFFF",
  turquoise: "#5CC6C7",
  fadedTurquoise: "#7eb1b7",
  cyan: "#71DCDD",
  mint: "#B8F1F1",
  dew: "#EAFFFF",
  // blues
  blue: "#50AEEB",
  lightBlueGray: "#77A6E2",
  blueGray: "#6A9AD6",
  steelBlue: "#477ab9",
  aliceBlue: "#EBF4FF",
  pictonBlue: "#5B8DCB",
  chambrayBlue: "#35587D",
  cornflowerBlue: "#84ade0",
  regentBlue: "#99bae2",
  frenchBlue: "#BDDBFF",
  danubeBlue: "#5B8DCB",
  jordyBlue: "#77A6E2",
  indigoBlue: "#4982C9",
  blueBayoux: "#4c6372",
  fadedBlue: "#87B1E5",
  yellow: "#EDCE68",
  lightYellow: "#ffe9b8",
  nude: "#EFDAC4",
  mutedOrange: "#EFC89F",
  orange: "#EDAD68",
  darkOrange: "#DB9D5A",
  red: "#C76358",
  darkRed: "#B75B51",
  mutedRed: "#ff9289",
  pink: "#E1718B",
  lightPink: "#FFEDF1",
  mediumPink: "#F298AE",
  sweetPink: "#FA9FB4",
  darkPink: "#DB6580",
  orchid: "#DA72C5",
  // purples
  portGorePurple: "#24245A",
  minskPurple: "#333377",
  blueVioletPurple: "#4343B5",
  indigoPurple: "#5656C2",
  titanWhitePurple: "#E5E5FE",
  lavenderPurple: "#A6A6E9",
  moodyPurple: "#6c69d8",
  // greens
  mintGreen: "#93FFB3",
  bermudaGreen: "#7ADDB6",
  pastelGreen: "#65E87E",
  chateauGreen: "#3FB254",
  // grays
  galleryGray: "#F0F0F0",
  silverGray: "#C4C4C4",
  silverLightGray: "#BEBEBE",
  silverChaliceGray: "#A2A2A2",
  doveGray: "#707070",
  regentGray: "#939EA4",
  darkSlateGray: "#364c5a",
  transparentWhite: _toConsumableArray(new Array(10).keys()).map( // eg. transparentWhite.9 has opacity 0.9
  function (i) {
    return "rgba(255, 255, 255, ".concat(i / 10, ")");
  }),
  transparentBlack: _toConsumableArray(new Array(10).keys()).map( // eg. transparentBlack.9 has opacity 0.9
  function (i) {
    return "rgba(39, 60, 73, ".concat(i / 10, ")");
  })
}; // global button styles

exports.colors = colors;
colors.darkButton = {
  default: colors.black,
  hover: "#385264",
  active: "#627886",
  text: colors.white
};
colors.dangerButton = {
  default: colors.red,
  hover: "#E07266",
  active: "#EA8C81",
  text: colors.white
};
colors.successButton = {
  default: colors.turquoise,
  hover: "#85E2E3",
  active: "#B2F8F8",
  text: colors.black
};
colors.disabledButton = {
  default: colors.silverGray,
  hover: colors.silverGray,
  active: colors.silverGray,
  text: colors.black
};
colors.primaryButton = {
  default: colors.turquoise,
  hover: "#85E2E3",
  active: "#B2F8F8",
  text: colors.black
}; // links

colors.darkLink = {
  default: colors.black,
  hover: colors.white
};
colors.lightLink = {
  default: colors.white,
  hover: colors.black
};
colors.primaryLink = {
  default: colors.turquoise,
  hover: "#85E2E3"
}; // modal

colors.modalBg = colors.white;
colors.modalHeaderBg = colors.white;
colors.modalText = colors.black;
colors.backdrop = "rgba(39, 60, 73, 0.9)";
var fonts = {
  headings: "Times, serif",
  body: "'Helvetica', Arial, sans-serif"
};
var theme = {
  colors: colors,
  fonts: fonts,
  shadows: shadows,
  space: space,
  fontSizes: fontSizes,
  zIndexes: zIndexes
};
var _default = theme;
exports.default = _default;